<template>
  <div class="projects">
    <section v-if="publicTalks.length" class="public-talks">
      <h2>Conferences &amp; public talks</h2>
      <div
        v-for="talk in publicTalks"
        :key="talk.id"
        class="talk-card"
      >
        <h3>{{ talk.title }}</h3>
        <ItemLinks :links="talk.links" />
      </div>
    </section>

    <h1>Projects</h1>
    <p>Мои проекты и разработки. Нажмите на карточку, чтобы увидеть подробности:</p>
    
    <div class="project-cards">
      <router-link 
        v-for="project in projects" 
        :key="project.id"
        :to="`/projects/${project.id}`" 
        class="project-card"
      >
        <div class="project-card-content">
          <h2>{{ project.title }}</h2>
          
          <!-- Conditional rendering for short description -->
          <p v-if="project.shortDescription" class="project-description">
            {{ project.shortDescription }}
          </p>
          
          <!-- Conditional rendering for period -->
          <p v-if="project.period" class="project-period">
            {{ project.period }}
          </p>
          
          <!-- Conditional rendering for technologies -->
          <div class="technologies" v-if="project.technologies && project.technologies.length">
            <span 
              v-for="tech in project.technologies.slice(0, 3)" 
              :key="tech" 
              class="tech-tag"
            >
              {{ tech }}
            </span>
            <span 
              v-if="project.technologies.length > 3" 
              class="tech-tag more"
            >
              +{{ project.technologies.length - 3 }}
            </span>
          </div>
        </div>
      </router-link>
    </div>
  </div>
</template>

<script>
import ItemLinks from '../components/ItemLinks.vue';
import { projects } from '../stores/projects';
import { publicTalks } from '../stores/publicTalks';

export default {
  name: 'ProjectsPage',
  components: {
    ItemLinks,
  },
  data() {
    return {
      projects,
      publicTalks,
    };
  }
};
</script>

<style scoped>
.projects {
  max-width: 800px;
  margin: 2rem auto;
  padding: 2rem;
}

.public-talks {
  margin-bottom: 3rem;
}

.public-talks h2 {
  color: #569cd6;
  font-weight: 600;
  margin: 0 0 1.25rem 0;
}

.talk-card {
  background-color: #2d2d2d;
  border: 1px solid #444;
  border-radius: 8px;
  padding: 1.5rem;
  margin-bottom: 1rem;
}

.talk-card h3 {
  color: #4ec9b0;
  font-weight: 500;
  margin: 0 0 0.75rem 0;
  font-size: 1.1rem;
}

.project-cards {
  display: flex;
  flex-direction: column;
  gap: 1.5rem;
}

.project-card {
  background-color: #2d2d2d;
  border-radius: 8px;
  color: #d4d4d4;
  text-decoration: none;
  transition: all 0.3s ease;
  display: flex;
  flex-direction: column;
  padding: 1.5rem;
  border: 1px solid #444;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.2);
}

.project-card:hover {
  background-color: #363636;
  transform: translateY(-2px);
  box-shadow: 0 6px 16px rgba(0, 0, 0, 0.3);
}

.project-card-content {
  flex: 1;
}

h1 {
  color: #d4d4d4;
  font-weight: 600;
  margin-bottom: 1rem;
}

h2 {
  color: #4ec9b0;
  font-weight: 500;
  margin: 0 0 0.5rem 0;
}

.project-description {
  color: #d4d4d4;
  margin: 0.5rem 0;
  line-height: 1.5;
}

.project-period {
  color: #9cdcfe;
  font-size: 0.9rem;
  margin: 0.5rem 0;
  font-weight: 400;
}

.technologies {
  display: flex;
  gap: 0.5rem;
  margin-top: 1rem;
  flex-wrap: wrap;
}

.tech-tag {
  background-color: #1e1e1e;
  padding: 0.3rem 0.8rem;
  border-radius: 3px;
  font-size: 0.8rem;
  color: #ce9178;
  border: 1px solid #333;
}

.tech-tag.more {
  background-color: #333;
  color: #999;
}
</style> 